import React from 'react';
import './styles/About.css';
import aboutImage from '../assets/movers.jpg'; // Replace with your actual image

const About = () => {
  return (
    <div className="about-container">
      <img src={aboutImage} alt="About Movingbay" className="about-image" />
      <div className="about-text">
        <h2>MovingBay: Where Your Pets Travel with Love, Safety, and Care</h2>
        <p>
          Welcome to MovingBay, your trusted partner in pet relocation. Whether you’re moving across India or to a new country, we understand that your pets are family. That’s why we offer safe, stress-free, and professional pet moving solutions tailored to your needs.
        </p>
        <p>With years of experience in domestic and international pet relocation, MovingBay ensures your furry friends travel in comfort and security.</p>
      </div>
    </div>
  );
};

export default About;
